module.exports = __webpack_public_path__ + "img/prenominas1.fc9267d0.svg";